export const toQueryString = (object) => {
    let queryString = '?';
    for (const key in object) {
        if (object.hasOwnProperty(key) && typeof object[key] !== 'undefined' && object[key] !== null) {
            if (object[key] && typeof object[key] === 'object' && object[key].constructor === Array) {
                let arrayQuery = '';
                object[key].forEach((e) => {
                    arrayQuery += `${key}=${e}&`;
                });
                queryString += arrayQuery;
            } else {
                queryString += `${key}=${object[key]}&`;
            }
        }
    }
    queryString = queryString.slice(0, -1); // remove last & or ?
    return queryString;
};

export const getInviteParams = (url) => {
    const params = url.split('?');
    const splitUrl = params[0].split('/');
    const inviteId = splitUrl[splitUrl.length - 1];
    const searchParams = new URL(url).searchParams;
    const devicePartNumber = searchParams.get('devicePartNumber');
    const deviceName = searchParams.get('deviceName');

    return {
        inviteId,
        devicePartNumber,
        deviceName
    };
};

/**
 * Check if urlString is a valid URL.
 * Protocol is not required to match current requirement on Public Profile settings.
 * @param {string} urlString
 * @returns {boolean}
 */
export const isURL = (urlString) => {
    const pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', // fragment locator
        'i'
    );
    return pattern.test(urlString);
};
